/* eslint-disable react/no-children-prop */
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import Link from 'gatsby-core-theme/src/hooks/link';
import LazyImage from 'gatsby-core-theme/src/hooks/lazy-image';
import styles from './tournament.module.scss';

export const DefImg = ({ isStorybook = false, alt = '' }) => (
  <img
    alt={alt}
    src={
      isStorybook ? './flags/european_union.svg' : '../../../../../images/flags/european_union.svg'
    }
    width={29}
    height={29}
  />
);

// Test for this component is included in cards organism test
const TournamentCard = ({ item, isStorybook = false }) => {
  const league = item.relation.tournaments?.length > 0 && item.relation.tournaments[0];

  if (!league) {
    return <></>;
  }

  return (
    <div className={styles.container}>
      {league.country_code && (
        <LazyImage
          src={
            league.country_code !== 'international' && league.country_code !== 'int'
              ? `../../../../../images/flags/${league.country_code}.svg`
              : '../../../../../images/flags/european_union.svg'
          }
          alt={league.name}
          width={29}
          height={29}
          offset={1400}
          defaultImg={<DefImg alt={league.name} isStorybook={isStorybook} />}
        />
      )}
      <Link children={item.title} to={item.path} className="leagues-gtm name-cta" />
    </div>
  );
};

TournamentCard.propTypes = {
  item: PropTypes.shape({ title: PropTypes.string }).isRequired,
  isStorybook: PropTypes.bool,
};

export default TournamentCard;
